import { SelectWithInput } from "@volt_developers/components";

import { TEST_IDS } from "constants/TestIds";

import { useBanksAutocomplete } from "./useBanksAutocomplete";

import type { Theme } from "@mui/material";
import type { SystemStyleObject } from "@mui/system";
import type { UUID } from "utils";

type AutocompleteOption = {
  label: string;
  value: UUID;
};

export interface BanksAutocompleteProps {
  formValueName: string;
  defaultValue?: AutocompleteOption;
  sx?: SystemStyleObject<Theme>;
}

export const BanksAutocomplete = function ({
  defaultValue,
  formValueName,
  sx,
}: BanksAutocompleteProps) {
  const {
    formField,
    isError,
    isLoading,
    getOptionLabel,
    handleChange,
    handleInputChange,
    options,
  } = useBanksAutocomplete<UUID>({
    defaultValue,
    formValueName,
  });

  return (
    <SelectWithInput.Autocomplete<UUID>
      {...formField}
      data-testid={TEST_IDS.banksAutocomplete}
      error={isError}
      getOptionLabel={getOptionLabel}
      isLoading={isLoading}
      options={options}
      sx={sx}
      onInputChange={handleInputChange}
      onChange={handleChange}
    />
  );
};
